import { render, staticRenderFns } from "./ClinicOnLineTableCmp1.vue?vue&type=template&id=5f2bb42c&scoped=true&"
import script from "./ClinicOnLineTableCmp1.vue?vue&type=script&lang=js&"
export * from "./ClinicOnLineTableCmp1.vue?vue&type=script&lang=js&"
import style0 from "./ClinicOnLineTableCmp1.vue?vue&type=style&index=0&id=5f2bb42c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2bb42c",
  null
  
)

export default component.exports